// Single typed accessor for build-time env vars.
//
// Vite substitutes `process.env.VITE_*` at build time via the `define` block
// in vite.config.mts. That substitution only works for *static* dot-notation
// accesses (`process.env.VITE_FOO`) — dynamic `process.env[key]` reads are not
// replaced and resolve to `undefined` in the browser bundle. So each var must
// be read as a literal below. Jest loads `.env` into a real `process.env` via
// `jest/setupEnv.cjs`, so the same literal accesses work in tests too.

export const env = {
  env: process.env.VITE_ENV ?? '',
  appUrl: process.env.VITE_APP_URL ?? '',
  apiUrl: process.env.VITE_API_URL ?? '',
  sentryDsn: process.env.VITE_SENTRY_DSN ?? '',
  amplitudeKey: process.env.VITE_AMPLITUDE_KEY || undefined,
  amplitudeExperimentDeploymentKey:
    process.env.VITE_AMPLITUDE_API_EXPERIMENT_DEPLOYMENT_KEY || undefined,
  stripeKey: process.env.VITE_STRIPE_KEY ?? '',
  zendeskExtranetKey: process.env.VITE_ZENDESK_EXTRANET_KEY || undefined,
  nodeEnv: process.env.NODE_ENV,
};

export const isProduction = env.nodeEnv === 'production';
export const isDevelopment = env.nodeEnv === 'development';
